import { render, staticRenderFns } from "./wheattypes.vue?vue&type=template&id=a104ea36&scoped=true&"
import script from "./wheattypes.vue?vue&type=script&lang=js&"
export * from "./wheattypes.vue?vue&type=script&lang=js&"
import style0 from "./wheattypes.vue?vue&type=style&index=0&id=a104ea36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a104ea36",
  null
  
)

export default component.exports